import { Edit } from '@mui/icons-material'
import {
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import KanseiBreadcrumbs from 'components/breadcrumb'
import KanseiButton from 'components/button'
import { groupApi } from 'hooks/api/group'
import { CompanyGroup } from 'types/group'

export default function GroupPage() {
  const [groups, setGroups] = useState<CompanyGroup[]>([])
  const navigate = useNavigate()

  useEffect(() => {
    groupApi()
      .getAll()
      .then((res) => {
        setGroups(res.data)
      })
      .catch((error) => {
        console.error('Error fetching groups:', error)
        alert('グループの取得に失敗しました。')
      })
  }, [])

  const toCreate = () => {
    navigate(`/group/create`)
  }

  const toDetail = (id: string) => {
    navigate(`/group/${id}`)
  }

  const showParentGroup = (parentId?: string) => {
    if (!parentId) {
      return 'なし'
    }
    const parentGroup = groups.find((group) => group.id === parentId)
    return parentGroup ? parentGroup.name : '不明な親グループ'
  }

  const links = [
    {
      title: 'グループ管理',
    },
  ]
  return (
    <Box>
      <KanseiBreadcrumbs links={links} style={{ marginBottom: '15px' }} />
      <KanseiButton onClick={toCreate}>新規作成</KanseiButton>
      <TableContainer component={Paper} sx={{ marginTop: '20px' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>編集</TableCell>
              <TableCell>名前</TableCell>
              <TableCell>親グループ</TableCell>
              <TableCell>削除日</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {groups.map((group) => (
              <TableRow key={group.id}>
                <TableCell>
                  <IconButton
                    color="primary"
                    onClick={() => toDetail(group.id)}
                    size="small"
                  >
                    <Edit />
                  </IconButton>
                </TableCell>
                <TableCell>{group.name}</TableCell>
                <TableCell>{showParentGroup(group.parentId)}</TableCell>
                <TableCell>
                  {group.deletedAt
                    ? dayjs(group.deletedAt).format('YYYY-MM-DD')
                    : 'なし'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
